import { get, post, put, deleteReq } from './api';

export const fetchCurrentUser = () => get(`/users/me`);

export const fetchUsers = () => get(`/admin/users`);

export const createNewUser = user =>
  post(`/admin/users/`, JSON.stringify(user), {
    'Content-Type': 'application/json',
  });

export const editUser = ({ user }) =>
  put(`/admin/users/${user.id}`, JSON.stringify({ user }), {
    'Content-Type': 'application/json',
  });

export const deleteUser = ({ id }) =>
  deleteReq(`/admin/users/${id}`, {
    'Content-Type': 'application/json',
  });

export const blockUser = ({ user }) =>
  put(`/admin/users/${user.id}/block`, {
    'Content-Type': 'application/json',
  });

export const unblockUser = ({ user }) =>
  put(`/admin/users/${user.id}/unblock`, {
    'Content-Type': 'application/json',
  });

export const fetchUser = ({ id }) => get(`/admin/users/${id}`);



// WEBPACK FOOTER //
// ./src/services/userApi.js